import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const RoundedBottomGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 2600 48.6",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 48.6),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "m0 48.6h1291.9c-658.1 0-1291.9-48.6-1291.9-48.6zm1291.9 0h1308.1v-48.6s-650 48.6-1308.1 48.6z",
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    })
  });
};

export { RoundedBottomGraphic };
//# sourceMappingURL=rounded.bottom.js.map
